<mat-form-field *ngIf="dateControl">
    <mat-label>{{label}}</mat-label>
    <input type="text"
           autocompleteOff
           matInput
           [matDatepicker]="datePicker"
           [matDatepickerFilter]="datepickerFilter"
           [formControl]="dateControl"
           placeholder="{{'common.for-example' | translate }} {{ thisMonth | date: dateTimeFormats.yearAndMonth }}"
        (input)="onDateChange()" />
    <mat-hint align="start"><strong>{{hintLabel}}</strong> </mat-hint>
    <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
    <mat-datepicker #datePicker
                    startView="multi-year"
                    (yearSelected)="chosenYearHandler($event)"
                    (monthSelected)="chosenMonthHandler($event, datePicker)"
                    panelClass="example-month-picker">
    </mat-datepicker>
    <mat-error *ngIf="hasDateRangeError">{{'portal.erp.business-year.validation-message' | translate}}</mat-error>
</mat-form-field>
